import React from 'react'
import InventoryFilters from '../InventoryFilters'
import { StickyFiltersProps } from './StickyFilters.types'
import styles from './StickyFilters.module.scss'
import {
  useInventoryFiltersExpanded,
  useInventoryReportActions,
} from '../../../../store/inventoryReport'

const StickyFilters: React.FC<StickyFiltersProps> = ({
  filters,
  onFiltersChange,
  assets,
  goBack,
  goForward,
  canGoBack,
  canGoForward,
  onReset,
  handleDownload,
  totalCount,
}) => {
  const isExpanded = useInventoryFiltersExpanded()
  const { setFiltersExpanded } = useInventoryReportActions()

  const handleFilterExpand = (expanded: boolean) => {
    setFiltersExpanded(expanded)
  }

  return (
    <div className={styles.stickyWrapper}>
      <InventoryFilters
        filters={filters}
        onFiltersChange={onFiltersChange}
        assets={assets}
        onExpandChange={handleFilterExpand}
        goBack={goBack}
        goForward={goForward}
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        onReset={onReset}
        handleDownload={handleDownload}
        totalCount={totalCount}
        initialExpanded={isExpanded}
      />
    </div>
  )
}

export default StickyFilters
